import { MasterQuestionConfig } from "../questionnaires/questionnaireConfig/models";

import * as questionIds from "./questionIds";

export const masterConfig: MasterQuestionConfig[] = [
    // Referral Outcome Report (Physiotherapy)
    {
        id: questionIds.HrManager,
        questionText: "HR/Manager",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployeeSeen,
        questionText: "Employee Seen",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployeeAddress,
        questionText: "Address",
        canBeDisabled: false
    },
    {
        id: questionIds.Dob,
        questionText: "Date of Birth",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployerAndDivision,
        questionText: "Employer and Division",
        canBeDisabled: false
    },
    {
        id: questionIds.JobTitle,
        questionText: "Job Title",
        canBeDisabled: false
    },
    {
        id: questionIds.DateOfConsultation,
        questionText: "Date of Consultation",
        canBeDisabled: false
    },
    {
        id: questionIds.ConsultationType,
        questionText: "Consultation Type",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployeeId,
        questionText: "Employee Unique Id",
        canBeDisabled: false
    },
    {
        id: questionIds.ReportType,
        questionText: "Report Type",
        canBeDisabled: false
    },
    // Summary
    {
        id: questionIds.WorkClassification,
        questionText: "Work Classification",
        canBeDisabled: false
    },
    {
        id: questionIds.FirstDayOfAbsence,
        questionText: "First Day of Absence",
        canBeDisabled: false
    },
    {
        id: questionIds.AdvisedTargetReturnToWorkDate,
        questionText: "Advised Target Return to Work Date",
        canBeDisabled: false
    },
    {
        id: questionIds.FitnessOutcome,
        questionText: "Fitness Outcome",
        canBeDisabled: false
    },
    {
        id: questionIds.Adjustments,
        questionText: "Adjustments",
        canBeDisabled: false
    },
    {
        id: questionIds.AdjustmentsRecommended,
        questionText: "Adjustments recommended",
        canBeDisabled: false
    },
    {
        id: questionIds.AdjustmentsEndDate,
        questionText: "End Date of Temporary Adjustments",
        canBeDisabled: false
    },
    {
        id: questionIds.PhasedReturnToWorkRecommended,
        questionText: "Phased Return to Work recommended?",
        canBeDisabled: false
    },
    {
        id: questionIds.DurationOfPhasedReturn,
        questionText: "Recommended Length of Phased Return",
        canBeDisabled: false
    },
    {
        id: questionIds.OnwardReferral,
        questionText: "Onward Referral",
        canBeDisabled: false
    },
    {
        id: questionIds.GpSpecialistReportRequested,
        questionText: "GP/Specialist Report Requested",
        canBeDisabled: false
    },
    {
        id: questionIds.EqualityActLikelyToApply,
        questionText: "Is the Equality Act Likely to Apply",
        canBeDisabled: false
    },
    {
        id: questionIds.JustificationForEqualityActOpinion,
        questionText: "Justification for Equality Act Opinion",
        canBeDisabled: false
    },
    {
        id: questionIds.ReasonForReferral,
        questionText: "Reason for Referral",
        canBeDisabled: false
    },
    {
        id: questionIds.SelfManagementWithAdviceAndExercises,
        questionText: "Self-Management with Advice and Exercises",
        canBeDisabled: false
    },
    // Background and Reason for Referral
    {
        id: questionIds.BackgroundReasonsForReferral,
        questionText: "",
        canBeDisabled: false
    },
    // Assessment and Opinions
    {
        id: questionIds.AssessmentAndOpinions,
        questionText: "",
        canBeDisabled: false
    },
    // Information/Answers
    {
        id: questionIds.RecommendationsAndSummary,
        questionText: "",
        canBeDisabled: false
    },
    // Physiotherapy Specific Recommendations
    {
        id: questionIds.StandingAndWalkingRecommendations,
        questionText: "Recommendations",
        canBeDisabled: false
    },
    {
        id: questionIds.StandingAndWalkingTimeFrame,
        questionText: "Time Frame",
        canBeDisabled: false
    },
    {
        id: questionIds.SquattingKneelingSteppingRecommendations,
        questionText: "Recommendations",
        canBeDisabled: false
    },
    {
        id: questionIds.SquattingKneelingSteppingTimeFrame,
        questionText: "Time Frame",
        canBeDisabled: false
    },
    {
        id: questionIds.GripStrengthWorkingAtShoulderHeightOrAboveHeadRecommendations,
        questionText: "Recommendations",
        canBeDisabled: false
    },
    {
        id: questionIds.GripStrengthWorkingAtShoulderHeightOrAboveHeadTimeFrame,
        questionText: "Time Frame",
        canBeDisabled: false
    },
    {
        id: questionIds.LiftingCarryingRecommendations,
        questionText: "Recommendations",
        canBeDisabled: false
    },
    {
        id: questionIds.LiftingCarryingTimeFrame,
        questionText: "Time Frame",
        canBeDisabled: false
    },
    {
        id: questionIds.PushingPullingRecommendations,
        questionText: "Recommendations",
        canBeDisabled: false
    },
    {
        id: questionIds.PushingPullingTimeFrame,
        questionText: "Time Frame",
        canBeDisabled: false
    },
    {
        id: questionIds.SeatedActivitiesDeskWorkAndDrivingRecommendations,
        questionText: "Recommendations",
        canBeDisabled: false
    },
    {
        id: questionIds.SeatedActivitiesDeskWorkAndDrivingTimeFrame,
        questionText: "Time Frame",
        canBeDisabled: false
    },
    {
        id: questionIds.PMVA_CAndRRecommendations,
        questionText: "Recommendations",
        canBeDisabled: false
    },
    {
        id: questionIds.PMVA_CAndRTimeFrame,
        questionText: "Time Frame",
        canBeDisabled: false
    },
    {
        id: questionIds.PatientHandlingRecommendations,
        questionText: "Recommendations",
        canBeDisabled: false
    },
    {
        id: questionIds.PatientHandlingTimeFrame,
        questionText: "Time Frame",
        canBeDisabled: false
    },
    // Discharge after Treatment Information
    {
        id: questionIds.NumberOfSessionsIncludingInitialAssessment,
        questionText: "Number of sessions (including initial assessment)",
        canBeDisabled: false
    },
    {
        id: questionIds.ManagementDetails,
        questionText: "Management Details",
        canBeDisabled: false
    },
    {
        id: questionIds.Outcome,
        questionText: "Outcome",
        canBeDisabled: false
    },
    {
        id: questionIds.WorkStatusAtInitialAssessment,
        questionText: "Work Status at initial assessment",
        canBeDisabled: false
    },
    {
        id: questionIds.WorkStatusAtDischarge,
        questionText: "Work Status at discharge",
        canBeDisabled: false
    },
    {
        id: questionIds.QuestionnaireScoresAtInitialAssessment,
        questionText: "Questionnaire Scores (at initial assessment)",
        canBeDisabled: false
    },
    {
        id: questionIds.QuestionnaireScoresAtDischarge,
        questionText: "Questionnaire Scores (at discharge)",
        canBeDisabled: false
    },
    // Report Details
    {
        id: questionIds.ReportDate,
        questionText: "Report Date",
        canBeDisabled: false
    },
    {
        id: questionIds.CliniciansId,
        questionText: "Occupational Health Adviser",
        canBeDisabled: false
    },
    {
        id: questionIds.CliniciansName,
        questionText: "Occupational Health Adviser",
        canBeDisabled: false
    },
    {
        id: questionIds.CliniciansQualification,
        questionText: "Clinician Qualification",
        canBeDisabled: false
    },
    {
        id: questionIds.CliniciansEmail,
        questionText: "Clinician's email",
        canBeDisabled: false
    }
];
